import { Form, Drawer, Switch } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ingredient } from "../../API/UserManagement/ActiveIngredient";
import { useAppDispatch } from "../../app/hooks";
import { createActiveIngredient } from "../../slices/ActiveIngredients/Helpers/CreateActiveIngredient";
import { getAllIngredient } from "../../slices/ActiveIngredients/Helpers/getAllIngredients";
import ReusableForm from "../../unity-ui-common/Components/ReForm";
import ReInput from "../../unity-ui-common/Components/ReFormFields/ReInput";
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";
import ReSelect from "../../unity-ui-common/Components/ReFormFields/ReSelect";
function ActiveIngredientDrawer(props: {
  drawerType: string;
  visibility: boolean;
  setVisibility: Function;
  currentEditingIngredient?: any;
}) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const { drawerType, visibility, setVisibility, currentEditingIngredient } =
    props;
  const [switchStatus, setSwitchStatus] = useState(0);

  const onClose = () => {
    setVisibility({
      visibility: false,
    });
    setSwitchStatus(0);
    form.resetFields();
  };

  const submitFormHandler = async (values: any) => {
    const payload = {
      name: values.name,
      ATCCode: values.ATCCode,
      status: switchStatus,
      uniqueID: currentEditingIngredient?.id,
      strengths: values?.strengths,
    };
    if (drawerType === "create") {
      dispatch(createActiveIngredient(payload));
    } else if (drawerType === "edit") {
      const res = await ingredient.update(
        currentEditingIngredient.uniqueID,
        payload
      );
      const apiResponse = await res?.json();
      const isSuccess = !!apiResponse?.id;
      ReNotification({
        description: `Active-Ingredient ${
          isSuccess ? "Updated Successfully" : "Update Fail"
        }.`,
        type: isSuccess ? "success" : "error",
      });
    }
    onClose();
    dispatch(getAllIngredient());
  };

  useEffect(() => {
    dispatch(getAllIngredient());
    if (drawerType === "edit") {
      form.setFieldsValue({
        name: currentEditingIngredient?.name,
        ATCCode: currentEditingIngredient?.ATCCode,
        uniqueID: currentEditingIngredient.uniqueID,
        strengths: currentEditingIngredient?.strengths || [],
      });
      setSwitchStatus(currentEditingIngredient?.status);
    }
  }, [drawerType]);
  const strengthOptions = useMemo(() => 
    Array.from({ length: 10001 }, (_, i) => ({
      value: `${i / 1000}mg`,
      title: `${i / 1000} mg`,
  })),[]);
  return (
    <div>
      <Drawer
        placement="right"
        onClose={onClose}
        open={visibility}
        title={
          drawerType === "edit"
            ? "Update Active Ingredient"
            : "Create Active Ingredient"
        }
      >
        <ReusableForm
          formInstance={form}
          onSubmit={submitFormHandler}
          submitBtn
        >
          <ReInput label="Name" name="name" required type="simple" />
          <ReInput label="ATC Code" name="ATCCode" required type="simple" />
          <ReSelect
            label="Strengths"
            name="strengths"
            items={strengthOptions}
            required
            type="multiple" // Allow multiple selections
            searchable
          />
          <Form.Item label="Status" rules={[{ required: true }]}>
            <Switch
              checked={switchStatus === 1}
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              onChange={(checked) => {
                setSwitchStatus(checked ? 1 : 0);
              }}
            />
          </Form.Item>
        </ReusableForm>
      </Drawer>
    </div>
  );
}

export default ActiveIngredientDrawer;
